// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-iwiki"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21V21H3V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21V21H3V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 8V15.9968H7.03516L11.9805 8.50294H12L13.5 15.9968H13.5273L16.8867 8.25391M16.8867 8.25391L17 8H16.9844L16.8867 8.25391Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LogoIwikiIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-iwiki',
    ref,
    icon: element,
  },
));

LogoIwikiIcon.displayName = 'LogoIwikiIcon';

export default LogoIwikiIcon;
